import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import { elapsedTime, durationTime } from '@/utils/dateUtils'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  sorting: {
    sortBy: 'createdDate',
    sortDesc: true,
  },
  approvalFlows: [],
  files: [],
  serviceRequest: null,
  filters: {
    status: true,
    entityId: null,
    type: 'ServiceRequest',
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_SERVICE_REQUEST(state, serviceRequest) {
      state.serviceRequest = serviceRequest
    },
    SET_FILES(state, file) {
      state.files = file
    },
    SET_APPROVAL_FLOWS(state, approvalFlows) {
      state.approvalFlows = approvalFlows
    },
    SET_FILTER(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { serviceRequest, approvalFlow, filters } = getInitialState()
      state.serviceRequest = serviceRequest
      state.approvalFlow = approvalFlow
      state.filters = filters
    },
    CLEAN_FILE(state) {
      const { files } = getInitialState()
      state.files = files
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchApprovalFlows({ commit, state }, serviceRequestId) {
      const { data } = await axios.get('/api/approval-flows/transactions', {
        params: {
          type: 'ServiceRequest',
          entityId: serviceRequestId,
          onlyAboutMe: false,
          sortBy: sorting.methods.getSorting(state),
        },
      })
      if (data.results) {
        data.results.forEach(approvalFlow => {
          approvalFlow.steps.forEach(step => {
            const stepCopy = { ...step }
            if (step.approvalDate) {
              stepCopy.elapsedTimeFormat = elapsedTime(stepCopy.approvalDate, '', true, false)
              stepCopy.durationTimeFormat = durationTime(
                stepCopy.startDate,
                stepCopy.approvalDate,
                ''
              )
            } else {
              // stepCopy.elapsedTimeFormat = `Pendente à ${elapsedTime(stepCopy.startDate, '', false, false)}`
            }
            Object.assign(step, stepCopy)
          })
        })
      }
      commit('SET_APPROVAL_FLOWS', data.results || [])
    },
    removeDocument({ state }, documentId) {
      const index = state.serviceRequest.documents.findIndex(f => f.id === documentId)
      state.serviceRequest.documents.splice(index, 1)
    },
    async uploadDocuments({ state }, entityId) {
      // O grupo repetível sempre renderiza uma linha em branco, e a exclusão de um anexo deixa o
      // item sem arquivo. Só envia os itens que realmente têm um arquivo selecionado.
      const filesToUpload = state.files.filter(f => !f.id && f.file?.file)
      if (filesToUpload.length > 0) {
        const formData = new FormData()
        formData.append('entityId', entityId)
        formData.append('uploadType', 'ServiceRequest')
        filesToUpload.forEach(localFile => {
          formData.append('files', localFile.file.file)
          formData.append('types', 'Others')
        })
        await axios.post(`/api/documents/upload-files`, formData)
      }
    },

    async fetchServiceRequest({ commit }, id) {
      const { data } = await axios.get(`/api/service/requests/${id}`)
      commit('SET_SERVICE_REQUEST', data)
    },

    setServiceRequest({ commit }, serviceRequest) {
      commit('SET_SERVICE_REQUEST', serviceRequest)
    },

    deleteLocalFile({ commit, state }, index) {
      if (state.files[index]?.id) {
        commit('SET_FILES_DELETED', state.files[index].id)
      }
    },

    setFiles({ commit }, file) {
      commit('SET_FILES', file)
    },

    resetFilters({ commit }) {
      commit('SET_FILTER', getInitialState().filters)
    },
    cleanState({ commit }) {
      commit('CLEAN_STATE')
      commit('CLEAN_FILE')
    },
  },
}
